import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { Alert, Spin, Collapse, Button, message, Tag, Popconfirm, Space } from "antd"
import { PlusCircleOutlined, LeftCircleOutlined, EditOutlined } from '@ant-design/icons';
import { CountryApi } from "../../api/countryApi"
const { Panel } = Collapse;

const DetailsCountryView = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [country, setCountry] = useState(null)
    const [loading, setLoading] = useState(false)
    const [actionLoading, setActionLoading] = useState(false)
    const [error, setError] = useState(null);
    const abortController = new AbortController()

    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const res = await CountryApi.getCountryDetails(id, abortController.signal);
            setCountry(res.data);
        } catch (err) {
            setError("Impossible de charger les détails du pays.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const handleActivate = async () => {
        setActionLoading(true);
        try {
            const res = await CountryApi.activateCountry(id, abortController.signal);
            res.success ? message.success(res.message) : message.error(res.message);
            fetchData();
        } catch (error) {
            message.error("Échec de l'activation");
        } finally {
            setActionLoading(false);
        }
    }

    const handleDeactivate = async () => {
        setActionLoading(true);
        try {
            const res = await CountryApi.deactivateCountry(id, abortController.signal);
            res.success ? message.success(res.message) : message.error(res.message);
            fetchData();
        } catch (error) {
            message.error("Échec de la désactivation");
        } finally {
            setActionLoading(false);
        }
    }

    const handleDelete = async () => {
        setActionLoading(true);
        try {
            const res = await CountryApi.deleteCountry(id, abortController.signal);
            if (!res.success) {
                setActionLoading(false);
                return message.error(res.message);
            }
            message.success(res.message);
            navigate('/pays');
        } catch (error) {
            setActionLoading(false);
            message.error("Échec de la suppression");
        }
    }

    return <MainLayout>
        <div className="container mx-auto p-6">
            <div className="flex justify-between">
                <h1 className="text-3xl font-semibold mb-6">Détails du pays {country?.name}</h1>
                <Link to={`/pays`}><LeftCircleOutlined /> Retour  </Link>
            </div>

            {loading && <Spin size="large" />}
            {error && <Alert message={error} type="error" />}
            {!loading && !error && country && (
                <div className="bg-white p-6 rounded-lg shadow-md">
                    <Collapse defaultActiveKey={['1']} expandIconPosition="start">
                        <Panel header="Informations générales" key="1" extra={<PlusCircleOutlined />}>
                            <div className="space-y-4">
                                <p><strong>Nom :</strong> {country?.name}</p>
                                <p><strong>Code ISO :</strong> {country?.iso_code}</p>
                                <p><strong>Indicatif téléphonique :</strong> {country?.phone_code || 'Non renseigné'}</p>
                                <p><strong>Statut :</strong> {country?.is_active ? <Tag color="green">Actif</Tag> : <Tag color="red">Inactif</Tag>}</p>
                            </div>
                        </Panel>
                    </Collapse>

                    <div className="mt-6">
                        <Space wrap>
                            <Button icon={<EditOutlined />} onClick={() => navigate(`/pays/${id}/modifier`)}>
                                Modifier
                            </Button>

                            {!country?.is_active && (
                                <Button type="primary" loading={actionLoading} onClick={handleActivate}>
                                    Activer
                                </Button>
                            )}

                            {country?.is_active && (
                                <Button loading={actionLoading} onClick={handleDeactivate}>
                                    Désactiver
                                </Button>
                            )}

                            <Popconfirm title="Supprimer ce pays ?" onConfirm={handleDelete} okText="Oui" cancelText="Non">
                                <Button danger loading={actionLoading}>
                                    Supprimer
                                </Button>
                            </Popconfirm>
                        </Space>
                    </div>
                </div>
            )}
        </div>
    </MainLayout>
}
export default DetailsCountryView
